import React, { useEffect, useState } from 'react';
import { db, auth } from './firebase';
import { collection, query, orderBy, onSnapshot, limit, doc, getDoc, deleteDoc } from 'firebase/firestore';
import { Trash2 } from 'lucide-react';
import { moverSaldo } from './saldoUtilizador';

const FotoRemetente = ({ id }) => {
  const [foto, setFoto] = useState('https://placeholder.com');
  useEffect(() => {
    if (!id) return;
    getDoc(doc(db, "utilizadores", id)).then(snap => {
      if (snap.exists() && snap.data().fotoUrl) setFoto(snap.data().fotoUrl);
    });
  }, [id]);
  return <img src={foto} style={{ width: '40px', height: '40px', borderRadius: '50%', border: '1px solid #39FF14', objectFit: 'cover' }} alt="p" />;
};

const ListaNotificacoes = ({ aoClicar }) => { // Adicionámos o aoClicar aqui
  const [alertas, setAlertas] = useState([]);

  useEffect(() => {
    const uid = auth.currentUser?.uid;
    if (!uid) return;
    const q = query(collection(db, "utilizadores", uid, "notificacoes"), orderBy("timestamp", "desc"), limit(20));
    return onSnapshot(q, (snap) => {
      const lista = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      const agora = Date.now();
      const validos = [];

      lista.forEach((n) => {
        // AUTO-EXPIRAÇÃO: a recompensa de cashback da live tem prazo estrito de 7 dias.
        // Se "expiraEm" já passou, o documento auto-apaga-se e o prémio perde-se.
        const expMs = n.expiraEm?.toMillis ? n.expiraEm.toMillis()
          : (n.dados?.expiraEm?.toMillis ? n.dados.expiraEm.toMillis() : null);
        if (n.tipo === 'recompensa_ranking_live' && expMs && expMs < agora) {
          deleteDoc(doc(db, "utilizadores", uid, "notificacoes", n.id)).catch(() => {});
          return; // não entra na lista visível
        }
        validos.push(n);
      });

      setAlertas(validos);
    });
  }, []);

    const apagarNotificacao = async (id) => {
    try {
      const uid = auth.currentUser?.uid;
      await deleteDoc(doc(db, "utilizadores", uid, "notificacoes", id));
    } catch (e) { console.error("Erro ao apagar:", e); }
  };

    return (
    <div style={{ padding: '10px', background: '#000' }}>
      {alertas.map(alerta => (
        <div 
          key={alerta.id} 
          style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', borderBottom: '1px solid #222', color: 'white' }}
        >
          {/* FOTO: Clicar vai para o Perfil */}
          <div onClick={() => aoClicar(alerta.remetenteId)} style={{ cursor: 'pointer' }}>
            <FotoRemetente id={alerta.remetenteId} />
          </div>

                              {/* TEXTO COM MOTOR DE VALIDAÇÃO DE 7 DIAS E RESGATE (BLOCO DO TOSHIBA) */}
          <div 
  onClick={async () => {
    const info = alerta.dados ? alerta.dados : alerta;
    const tipoNotif = info.tipo || alerta.tipo;

    // TRANCA DE EXPIRAÇÃO: Só aplica se for especificamente a recompensa do bloco do Toshiba
if (alerta.tipo === 'recompensa_ranking_live' && alerta.timestamp) {
  const dataNotif = alerta.timestamp.toDate ? alerta.timestamp.toDate() : new Date(alerta.timestamp);
  const diasPassados = (new Date() - dataNotif) / (1000 * 60 * 60 * 24);
  if (diasPassados > 7) {
    await apagarNotificacao(alerta.id);
    alert("Esta recompensa expirou! O prazo de 7 dias para resgate terminou. 🟥");
    return;
  }
}

    // Encaminhamento da Notificação
    if (tipoNotif === 'seguidor' || tipoNotif === 'seguir') {
      aoClicar(info.remetenteId || alerta.remetenteId);
    } else if (tipoNotif === 'abriu_bancada' || tipoNotif === 'bancada_sala' || alerta.ecra === 'bancada_sala') {
      const idDaSalaAlvo = alerta.salaId || (alerta.dados && alerta.dados.salaId);
      window.dispatchEvent(new CustomEvent('abrirBancadaDireto', { detail: { salaId: idDaSalaAlvo } }));
    } else if (tipoNotif === 'live' || tipoNotif === 'live_partilhada') {
      const idDaLive = info.remetenteId || info.liveId || alerta.remetenteId;
      window.dispatchEvent(new CustomEvent('abrirLiveSoloDireto', { detail: { liveId: idDaLive } }));
    } else if (tipoNotif === 'like' || tipoNotif === 'comentario' || tipoNotif === 'presente' || tipoNotif === 'post_partilhado' || alerta.tipo === 'post_partilhado') {
      window.dispatchEvent(new CustomEvent('abrirPostEspecifico', { 
        detail: { 
          postId: info.postId || alerta.dados?.postId || alerta.postId, 
          tipo: tipoNotif,
          stickerUrl: info.videoUrl || alerta.dados?.videoUrl || info.url || alerta.dados?.url || ""
        } 
      }));
    } else if (tipoNotif === 'arena_pk' || tipoNotif === 'champions_pk') {
      const idDaBatalha = info.batalhaId || info.remetenteId || alerta.batalhaId;
      window.dispatchEvent(new CustomEvent('abrirBatalha', { detail: { batalhaId: idDaBatalha, tipo: tipoNotif } }));
    }
  }}
  style={{ fontSize: '14px', flex: 1, cursor: 'pointer' }}
>

  <span 
  onClick={(e) => {
    e.stopPropagation();
    aoClicar(alerta.remetenteId);
  }}
  style={{ color: '#39FF14', fontWeight: 'bold', cursor: 'pointer' }}
>
  {alerta.remetenteNome}{' '}
</span>

{/* TEXTOS GLOBAIS DE NOTIFICAÇÃO */}
{(alerta.tipo === 'seguidor' || alerta.tipo === 'seguir') && (alerta.dados?.textoCustom || alerta.textoCustom || " começou a seguir-te! ⚽🏃‍♂️")}
{alerta.tipo === 'presente' && (window.location.search.includes('emLive=true') ? " enviou-te um presente! 🎁" : " enviou um presente para um dos teus posts! 🎁")}
{alerta.tipo === 'like' && (alerta.textoCustom || " gostou do teu post! ❤️")}
{alerta.tipo === 'comentario' && (alerta.textoCustom || " comentou o teu post! 💬")}
{alerta.tipo === 'live' && " iniciou uma Live! 📺"}
{alerta.tipo === 'live_partilhada' && (alerta.dados?.textoCustom || " convidou-te para assistir a uma Live! 🏟️⚽")}
{alerta.tipo === 'post_partilhado' && (alerta.dados?.textoCustom || alerta.textoCustom || " partilhou uma publicação contigo! 🏟️⚽")}

{/* DESIGN PREMIUM E CHAMATIVO PARA RECOMPENSA DE MAIOR PRESENTEADOR */}
{alerta.tipo === 'recompensa_ranking_live' && (
  <div style={{
    background: 'linear-gradient(135deg, #111 0%, #000 100%)',
    border: '2px solid #FFD700',
    boxShadow: '0 0 15px rgba(255, 215, 0, 0.4), inset 0 0 10px rgba(255, 215, 0, 0.2)',
    borderRadius: '12px',
    padding: '15px',
    marginTop: '8px',
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    boxSizing: 'border-box'
  }}>
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span style={{ fontSize: '20px' }}>🏆</span>
      <span style={{ color: '#FFD700', fontWeight: '900', fontSize: '13px', textTransform: 'uppercase', letterSpacing: '1px' }}>
        BÓNUS RECOMPENSA DE LIVE
      </span>
    </div>
    
    <p style={{ color: '#fff', fontSize: '13px', margin: 0, lineHeight: '1.4', fontWeight: '500' }}>
      {alerta.dados?.textoCustom || `Parabéns! Foste o maior presenteador da Live! Tens um bónus de ${alerta.dados?.valorPremio || 0} ⚽ para resgatar!`}
    </p>

    {/* PRAZO ESTRITO DE 7 DIAS PARA RESGATE */}
{(() => {
  const exp = alerta.expiraEm?.toMillis ? alerta.expiraEm.toMillis()
    : (alerta.dados?.expiraEm?.toMillis ? alerta.dados.expiraEm.toMillis() : null);
  if (!exp) return null;
  const diasRestantes = Math.max(0, Math.ceil((exp - Date.now()) / (1000 * 60 * 60 * 24)));
  return (
    <span style={{ color: '#FFB300', fontSize: '11px', fontWeight: '700' }}>
      ⏳ Expira em {diasRestantes} dia(s) — resgata antes que se perca!
    </span>
  );
})()}

{/* BOTÃO DE RESGATE QUE ACUMULA O SALDO ATÉ O UTILIZADOR CLICAR */}
<button
  onClick={async (e) => {
    e.stopPropagation();
    try {
      const { getFunctions, httpsCallable } = await import('firebase/functions');
            // Força o ecrã a chamar o servidor correto na Europa
      const functions = getFunctions(undefined, 'europe-west1');
      // Liga o botão diretamente ao nosso motor blindado na Cloud
      const resgatarPremioRankingSeguro = httpsCallable(functions, 'resgatarPremioRankingSeguro');
      
      const resultado = await resgatarPremioRankingSeguro({ notificacaoId: alerta.id });
      
      if (resultado.data && resultado.data.sucesso) {
        alert(`GOLOOO! Resgataste ${resultado.data.valor.toLocaleString()} ⚽ com sucesso para o teu saldo! 🏟️🔥`);
      }
    } catch (errPremio) {
      console.error("Erro ao resgatar moedas do ranking:", errPremio);
      // Se a Cloud rejeitar por expiração ou fraude, mostra o erro limpo
      if (errPremio.message?.includes("RECOMPENSA_EXPIRADA")) {
        alert("Esta recompensa expirou! O prazo de 7 dias para resgate terminou. 🟥");
      } else {
        alert("Erro ao processar o teu resgate. Tenta novamente!");
      }
    }
  }}
  style={{
    background: '#FFD700',
    color: '#000',
    border: 'none',
    borderRadius: '25px',
    padding: '10px 15px',
    fontWeight: '900',
    fontSize: '12px',
    cursor: 'pointer',
    textTransform: 'uppercase',
    boxShadow: '0 0 10px #FFD700',
    width: '100%',
    textAlign: 'center',
    pointerEvents: 'auto'
  }}
>
  💰 RESGATAR MEU BÓNUS AGORA
</button>
</div>
)}

{alerta.tipo === 'arena_pk' && " está em Batalha na Arena! 🔥"}
{alerta.tipo === 'champions_pk' && " entrou em campo na Champions PK! 🏆"}
{alerta.tipo === 'chat' && " enviou-te uma mensagem privada! 💬"}
{alerta.tipo === 'abriu_bancada' && " abriu uma Bancada Real! 🏟️"}
</div>

          {/* BALDE DO LIXO */}
          <Trash2 
            size={18} 
            color="#666" 
            onClick={(e) => {
              e.stopPropagation();
              apagarNotificacao(alerta.id);
            }} 
            style={{ cursor: 'pointer', marginLeft: '10px' }} 
          />
        </div>
      ))}
    </div>
  );
};

export default ListaNotificacoes;



